// passando da pasta raiz para cá.

export const error = {
  generic: 'Algo deu errado!',
  filesProvider: {
    getFileList: 'Erro ao tentar carregar os arquivos.',
    getFile: 'Erro ao tentar carregar o arquivo',
    getCurrentCompanyStorage: 'Erro ao tentar carregar informações de armazenamento.',
    downloadFile: 'Erro ao tentar fazer donwload do arquivo.',
    convertFile: 'Erro ao tentar reconfigurar o arquivo.',
    getSample: 'Erro ao tentar visualizar o arquivo.', // ?
    deleteFile: 'Erro ao tentar apagar o arquivo.',
    deleteGlobalFile: 'Erro ao tentar apagar arquivo.',
    uploadFile: 'Erro ao tentar fazer upload do arquivo.',
    uploadFileByLink: 'Erro ao tentar fazer upload do arquivo pelo link.',
    reopen: 'Erro ao tentar reabrir arquivo.',
    getUnique: 'Erro ao tentar pegar os valores únicos do arquivo.',
    baseUpdate: 'Erro ao tentar atualizar o arquivo.',
  },
  fetchGeneric: 'Erro na comunicação com o servidor.',
  useUsers: {
    getUsers: 'Erro ao tentar carregar as informações dos usuários.',
    editUser: 'Erro ao tentar editar as informações do usuário.',
    toggleBlock: 'Erro ao tentar bloquear/desbloquear usuário.',
    deleteUser: 'Erro ao tentar apagar o usuário.',
    addUser: 'Erro ao tentar criar novo usuário.',
    resetPW: 'Erro ao tentar resetar senha do usuário.',
  },
  useGridKpi: {
    getAllInfos: 'Erro ao tentar carregar as informações do dashboard',
    saveLayout: 'Erro ao tentar salvar o layout.',
    getReport: 'Erro ao tentar baixar o relatório',
    cloneCard: 'Erro ao tentar clonar card.',
    removeCard: 'Erro ao tentar remover card.',
    newSnap: 'Não foi possível criar um novo story.',
    editSnap: 'Não foi possível o story.',
    removeSnap: 'Não foi possível apagar o story.',
    createCard: 'Erro ao tentar criar kpi.',
    createInsight: 'Erro ao tentar criar um insigth.',
    // comments
    loadComments: 'Erro ao tentar carregar os comentários.',
    loadMoreComments: 'Erro ao tentar carregar mais comentários.',
    addComment: 'Erro ao tentar criar novo comentário.',
    editComment: 'Erro ao tentar editar o comentário.',
    archiveComment: 'Erro ao tentar apagar o comentário.',
    //
    setCardStyles: 'Erro ao tentar atualizar os estilos dos KPIs.',
    // template
    createTemplate: 'Erro ao tentar criar novo template.',
  },
  useGridDash: {
    generic: 'Algo deu errado!',
    fetchGeneric: 'Erro na comunicação com o servidor',
    dashNotFound: 'Dashboard não encontrado',
    kpiListNoFound: 'Lista de kpis não encontrado',
    layoutNotFound: 'Layout dos dashboards não foi encontrado',
    bookMarkDashboard: 'Erro ao tentar favoritar dashboard.',
    genRequiredFromDashboard: 'Erro ao tentar acessar informações do dashboard.',
  },
  instance: {
    edit: 'Aconteceu algum erro enquanto tentávamos editar a instância',
    create: 'Aconteceu algum erro enquanto tentávamos criar a instância',
  },
  optmize: {
    dateFormat: 'Data com formato diferente do selecionado',
    missingDateFormat: 'Não foi selecionado o formato para o tipo Data',
    stringToFloat: 'Campo com formato de texto não pode ser convertido para número real',
    stringToInt: 'Campo com formato de texto não pode ser convertido para número inteiro',
  },
  templateProvider: {
    getTemplate: 'Erro ao tentar carregar os templates.',
    createTemplate: 'Erro ao tentar criar template.',
  },
};

export const comfirm = {
  generic: 'Algo deu errado!',
};
